export interface GcoinsAward {
  name: string;
  gCoins: number;
}

export const GcoinsAwards: GcoinsAward[] = [
  { name: 'cup-ttt', gCoins: 45 },
  { name: 'water-bottle-ttt', gCoins: 35 },
  { name: 'notebook-ttt', gCoins: 20 },
  { name: 'pen-ttt', gCoins: 10 },
  { name: 'gift-card-decathlon-ttt', gCoins: 100 },
  { name: 'sticker-ttt', gCoins: 5 },
  { name: 'jumpcity-ticket-ttt', gCoins: 60 },
  { name: 'movement-arena-ticker-ttt', gCoins: 60 },
];
